import { IAction } from '~/src/store';

import { EContactAlertActions } from './index';

export type TSetCodeVerificationError = IAction<EContactAlertActions.SET_CODE_VERIFICATION_ERROR, string>;

const setCodeVerificationError = (error: string): TSetCodeVerificationError => ({
    type: EContactAlertActions.SET_CODE_VERIFICATION_ERROR,
    payload: error,
});

export default setCodeVerificationError;
